import { render, staticRenderFns } from "./quickview.vue?vue&type=template&id=64638c56&scoped=true&"
import script from "./quickview.vue?vue&type=script&lang=js&"
export * from "./quickview.vue?vue&type=script&lang=js&"
import style0 from "./quickview.vue?vue&type=style&index=0&id=64638c56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64638c56",
  null
  
)

export default component.exports